(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    } else {
        root.ES6ishClassCreate=factory();
    }
})(this,function(){
        'use strict'
    	return Object.create || function( obj ){
    	      function F() {}
    	      F.prototype = obj;
    	      return new F()
        };
});
